import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import createFoxGridContainer from 'fox-react/dist/components/FoxGrid/createFoxGridContainer';
import FoxButton from 'fox-react/dist/components/FoxButton';
import FoxGridColumn from 'fox-react/dist/components/FoxGrid/FoxGridColumn';
import columnNames from 'common/columnNames';
import gridNames from 'common/gridNames';
import lang from 'hh-shared/dist/language/services/languageService';
import InnerContentWrapper from 'hh-shared/dist/components/layout/InnerContentWrapper';
import actionsColumnGridDefaults from 'hh-shared/dist/consts/actionsColumnGridDefaults';

const propTypes = {
  onLoadData: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};

const defaultProps = {};

class AddressesManagementPage extends PureComponent {
  render() {
    const { onLoadData, match } = this.props;

    const FoxGridContainer = createFoxGridContainer(
      gridNames.addressesManagement,
    );

    return (
      <InnerContentWrapper fullWidth>
        <FoxGridContainer
          onLoadData={onLoadData}
          defaultSortField={columnNames.addressesManagement.street}
          renderButtons={
            <Link to={`${match.url}/add`}>
              <FoxButton icon="add" primary>
                {lang.buttons.Add()}
              </FoxButton>
            </Link>
          }
        >
          <FoxGridColumn
            {...actionsColumnGridDefaults}
            cell={({ dataItem }) => (
              <td>
                <Link to={`${match.url}/edit/${dataItem.instanceId}`}>
                  <FoxButton icon="edit">{lang.buttons.Edit()}</FoxButton>
                </Link>
              </td>
            )}
          />
          <FoxGridColumn
            field={columnNames.addressesManagement.street}
            title={lang.labels.Street()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.addressesManagement.zipCode}
            title={lang.labels.ZipCode()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.addressesManagement.city}
            title={lang.labels.City()}
            filter="text"
          />
        </FoxGridContainer>
      </InnerContentWrapper>
    );
  }
}

AddressesManagementPage.propTypes = propTypes;
AddressesManagementPage.defaultProps = defaultProps;

export default AddressesManagementPage;
